import { loadStripe } from '@stripe/stripe-js';

// Money comes in minor units (7990 = 79,90) with a lowercase ISO currency.
export const formatMoney = (amount, currency, locale) => (amount === null || amount === undefined || !currency ? ''
  : new Intl.NumberFormat(locale, { style: 'currency', currency: currency.toUpperCase() }).format(amount / 100));
export const formatCredits = (units, locale) => new Intl.NumberFormat(locale).format(units ?? 0);
export const formatDay = (iso, locale) => (iso ? new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(new Date(iso)) : '');
export const formatDate = (iso, locale) => (iso ? new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(iso)) : '');

// Stripe.js is loaded once per publishable key (served by `GET /studio/plans`). The
// `dahlia` build matches the core's API version: embedded checkout pages
// (`ui_mode: embedded_page`) mount through `createEmbeddedCheckoutPage`.
// A failed load (offline, blocked script) is forgotten so the next attempt retries.
const stripes = new Map();
export function stripeFor(publishableKey) {
  if (!stripes.has(publishableKey)) {
    stripes.set(publishableKey, loadStripe(publishableKey).then(stripe => {
      if (!stripe) throw new Error('Stripe.js is not available');
      return stripe;
    }).catch(failure => { stripes.delete(publishableKey); throw failure; }));
  }
  return stripes.get(publishableKey);
}
